import React, { Fragment } from "react";
import CenterScreen from "../../../components/wrappers/CenterScreen";
import { Alert, Button, Divider, Paper, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { useForm } from "react-hook-form";
import AuthFooter from "../login/component/AuthFooter";
import { LOGIN } from "../../../enums/UrlPaths";
import { DELETE_ACCOUNT_REQUEST, RESEND_VERIFICATION_EMAIL } from "../../../enums/ApiPaths";
import { HttpStatusCode } from "axios";
import api from "../../../utils/api/authApi";

export default function DeleteAccountPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [showGoBackButton, setShowGoBackButton] = React.useState(false);
  const { register, handleSubmit } = useForm();

  async function submitRequest(data) {
    try {
      const res = await api.post(
        `${DELETE_ACCOUNT_REQUEST}?email=${data.email}`
      );
      if (res.status === HttpStatusCode.Ok) {
        handleSnackbar("ActionCompletedSuccessfully", "success");
      }
    } catch (error) {
      handleSnackbar(error?.response?.data, "error");
    }
  }

  return (
    <Fragment>
      <CenterScreen minHeight="78vh">
        <Paper sx={{ p: { xs: 2, md: 4 }, width: "100%", maxWidth: 480 }}>
          <form onSubmit={handleSubmit(submitRequest)}>
            <Stack spacing={3}>
              <Typography variant="h5" fontWeight="bold">
                {t("DeleteUserTitle")}
              </Typography>
              <Divider />
              <Alert severity="warning">
                {t("AccountDeletionFirstStep")}
              </Alert>
              <TextField
                fullWidth
                required
                inputProps={{ maxLength: 255 }}
                label={t("Email")}
                {...register("email")}
              />
              <Stack spacing={1}>
                <Button type="submit" variant="contained" color="primary" fullWidth>
                  {t("Send")}
                </Button>
                <Button
                  onClick={() => navigate(LOGIN)}
                  variant={showGoBackButton ? "contained" : "outlined"}
                  color="primary"
                  fullWidth
                >
                  {t("GoBack")}
                </Button>
              </Stack>
            </Stack>
          </form>
        </Paper>
      </CenterScreen>
      <AuthFooter />
    </Fragment>
  );
}
